query primarySportFeeds($sportId: UUID) {
  allPrimaryFeeds {
    nodes {
      feed
    }
  }
  allSportFeeds: allSportMappings(
    filter: { mappedEntity: { sportId: { equalTo: $sportId } } }
  ) {
    nodes {
      feed
    }
  }
}
